<div class="ticket-info enVentas">
  <div [class]="claseConFiltro()">
    <ticketing-albaran-previo (movimiento)="onMovimiento($event)"></ticketing-albaran-previo>
    <div class="InputsBorder" [formGroup]="busquedaAlbaranForm">
      <input class="control-input-buscador" id="buscar-tpvId" type="text"
        formControlName="tpvId" category="ALFANUMERICO" (focus)="focusValue($event)" placeholder="Nº TPV">
      <img class="svg" src="assets/img/icon-search.svg" alt="icono cliente">
    </div>
    <div class="InputsBorder" [formGroup]="busquedaAlbaranForm">
      <input class="control-input-buscador" id="buscar-albaran" type="text"
        formControlName="query" category="ALFANUMERICO" (focus)="focusValue($event)" placeholder="{{ 'JUSTIFICANTE_No_ALBARAN' | translate }}">
      <img class="svg" src="assets/img/icon-search.svg" alt="icono cliente">
    </div>
    <ticketing-albaran-siguiente (movimiento)="onMovimiento($event)"></ticketing-albaran-siguiente>
    <div class="onoffswitch-wrapGeneral" *ngIf="mostrarFiltro()">
      <div class="onoffswitch-wrap checked">
        <div class="onoffswitch" [formGroup]="busquedaAlbaranForm">
          <input
            type="checkbox"
            name="filtrarCentroCheck"
            id="filtrarCentroCheck"
            class="onoffswitch-checkbox"
            formControlName="filtrarCentro"
            (change)="changefiltrarCentro()"
            [checked]="filtrarCentro"
          />
          <label class="onoffswitch-label" for="filtrarCentroCheck"></label>
        </div>
        <label class="onoffswitch-label-text" for="filtrarCentroCheck">{{
          'FILTRARCENTRO' | translate
        }}</label>
      </div>
    </div>
  </div>
</div>
